<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <vue-date-picker input-class="form-input" value-type="format" v-bind="$attrs" :value="value" @input="syncValue"></vue-date-picker>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
  import VueDatePicker from 'vue2-datepicker'
  export default {
    name: 'DateInput',
    components: {VueDatePicker},

    props: {
      id: {
        type: String,
        default() {
          return `text-input-${this._uid}`
        },
      },
      value: String,
      label: String,
      errors: {
        type: Array,
        default: () => [],
      }
    },

    methods: {
      syncValue(val) {
        this.$emit('input', val)
      }
    }

  }
</script>

<style scoped>
</style>
